export default {
  LALAMOVE: '#ff7043',
  DIMORDER: '#42a5f5',
}
